import styled from "@emotion/styled";
import { Link } from "react-router-dom";

export const Root = styled.div`
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  & .card-filter {
    margin: 24px 0;
    .theme-card-body {
      display: flex;
      gap: 12px;
      & > div:first-of-type {
        width: 20%;
      }
      & > div:nth-of-type(2) {
        width: 20%;
      }
      & > div:last-child {
        width: 60%;
      }
    }
  }
`;

export const Title = styled.p`
  font-size: 24px;
  font-weight: 500;
  color: #000000;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const TextUploadId = styled(Link)`
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: #3548c9;
  text-decoration: none;
  cursor: pointer;
  
`;

export const TextUploadFileName = styled.a`
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;

export const Status = styled.div<{ bg: string; color: string }>`
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 5px 12px;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: -0.2px;
  color: ${(props) => props.color};
  background: ${(props) => props.bg};
  border-radius: 100px;
`;
